import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "@tanstack/react-router";
import { useForm } from "react-hook-form";
import { useErrorDialog } from "@/shared/components/ErrorDialog";
import { useLogin } from "./api/auth.mutations";
import { type LoginInput, type LoginValues, loginSchema } from "./auth.schemas";
import { CredentialForm } from "./CredentialForm";

export function LoginPage() {
  const form = useForm<LoginInput, unknown, LoginValues>({
    resolver: zodResolver(loginSchema),
    defaultValues: { username: "", password: "" },
  });
  const login = useLogin();
  const navigate = useNavigate();
  const { showApiError } = useErrorDialog();

  const onSubmit = (values: LoginValues) =>
    login.mutate(values, {
      onSuccess: () => navigate({ to: "/" }),
      onError: (err) =>
        showApiError(err, { title: "Inloggningen misslyckades" }),
    });

  return (
    <CredentialForm
      form={form}
      onSubmit={onSubmit}
      heading="Logga in"
      submitLabel="Logga in"
      pending={login.isPending}
    />
  );
}
